import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { subscribeToSession, getSession } from '@/lib/api-client';
import { useAuthStore } from '@/store/auth.store';
import './styles.css';

// A 401 deep inside a fetch clears the session; React needs to hear about it.
subscribeToSession(() => {
  if (!getSession().accessToken && useAuthStore.getState().status === 'authenticated') {
    useAuthStore.setState({ status: 'unauthenticated', profile: null });
  }
});

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
